import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'y42-context-menu-color-button',
  templateUrl: './context-menu-color-button.component.html',
  styleUrls: ['./context-menu-color-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuColorButtonComponent {
  colorPickerOpened = false;

  @Input()
  color?: string;

  @Input()
  tooltip = '';

  @Input()
  faIcon: IconProp = ['far', 'circle'];

  @Input()
  inverse = false;

  @Input()
  nullable = false;

  @Input()
  addBackground = false;

  @Output()
  colorChanged = new EventEmitter<string>();
}
